import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const TabLoader = ({ message = "Loading..." }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box
      sx={{
        display:        "flex",
        flexDirection:  "column",
        alignItems:     "center",
        justifyContent: "center",
        gap:            2,
        minHeight:      "320px",
      }}
    >
      <CircularProgress size={28} sx={{ color: t.accent }} />
      <Typography sx={{ fontSize: "13px", color: t.text3 }}>{message}</Typography>
    </Box>
  );
};

export default TabLoader;
